export enum EvenStatusEnum {
  DO_NOT_SEND = "do_not_send",
  TO_SEND = "to_send",
  SENT = "sent",
  FAILED = "failed",
  CANCELLED = "cancelled",
}
